import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Layout from "./components/layout";

import {
  Reservations,
  Reviews,
  Support,
  Profile,
  PaymentSubscription,
  Favorites,
} from "./pages";

const routes = (locale: string | undefined = "") => [
  {
    path: `/${locale}`,
    element: <Layout />,
    children: [
      { path: "", element: <Navigate to="my-reservations" replace /> },
      {
        path: "my-reservations",
        element: <Reservations />,
      },
      {
        path: "my-reviews",
        element: <Reviews />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "payment",
        element: <PaymentSubscription />,
      },
      {
        path: "favorites",
        element: <Favorites />,
      },
    ],
  },
];

const router = createBrowserRouter([...routes(), ...routes(":locale")]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
